// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__934sE","buttons":"PendingPaymentAlert_buttons__1T-aP"};